export default __webpack_public_path__ + "static/media/Sign_out_squre.0c098090.svg";